/** Typed App Bridge transport, shared response validation; no builder decisions. */
import {
  shopifyStudyBuilderEvaluationResponseSchema,
  type ShopifyStudyBuilderEvaluationRequest,
} from '@testfeed/shopify-contracts'
import { shopifyApiClient } from '../../shopifyApiClient'
import type { ShopifyTokenSource } from '../../shopifyApiFetch'
import { throwMerchantFacingApiError } from '../../shopifyApiError'
import { parseContractPayload } from '../../merchantErrors'
export async function requestStudyBuilderEvaluation(
  shopify: ShopifyTokenSource,
  input: ShopifyStudyBuilderEvaluationRequest,
  signal: AbortSignal,
) {
  const response = await shopifyApiClient(shopify).api['study-builder'].evaluate.$post(
    { json: input },
    { init: { signal } },
  )
  // The Worker fills the merchant wording on the evaluate error; the builder renders it and passes no
  // copy of its own. A read failure with no server words surfaces as the server's `readiness.onReadFailure`.
  if (!response.ok) return throwMerchantFacingApiError(response, 'study-builder-evaluation')
  return parseContractPayload(
    'shopifyStudyBuilderEvaluationResponse',
    shopifyStudyBuilderEvaluationResponseSchema,
    await response.json(),
  )
}
